import React from "react";

type Props = {
  kind: string;
};

const baseProps = {
  width: 34,
  height: 34,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

const strokeColor = "currentColor";
const glowColor = "currentColor";

const WeatherIcon: React.FC<Props> = ({ kind }) => {
  switch (kind) {
    case "clear-day":
      return (
        <svg {...baseProps}>
          <circle cx="32" cy="32" r="11" fill={glowColor} fillOpacity="0.18" />
          <circle cx="32" cy="32" r="9" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" />
          {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => (
            <line
              key={deg}
              x1="32"
              y1="7"
              x2="32"
              y2="16"
              stroke={strokeColor} strokeOpacity="0.96"
              strokeWidth="3"
              strokeLinecap="round"
              transform={`rotate(${deg} 32 32)`}
            />
          ))}
        </svg>
      );
    case "clear-night":
      return (
        <svg {...baseProps}>
          <path
            d="M41 13c-10 1-18 10-18 21 0 8 4 15 11 19-2 .5-4 1-6 1-12 0-22-10-22-22S16 10 28 10c5 0 9 1 13 3Z"
            fill={glowColor} fillOpacity="0.18"
            stroke={strokeColor} strokeOpacity="0.96"
            strokeWidth="3"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "partly-cloudy-day":
    case "partly-cloudy-night":
      return (
        <svg {...baseProps}>
          <circle cx="24" cy="24" r="8" fill={glowColor} fillOpacity="0.18" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" />
          <path
            d="M21 46h24c6 0 11-4 11-10s-5-10-11-10c-1 0-2 0-3 .3C40 20 35 17 29 17c-8 0-14 5-16 12-6 .5-11 5-11 11 0 6 5 10 11 10h8Z"
            fill="currentColor" fillOpacity="0.12"
            stroke={strokeColor} strokeOpacity="0.96"
            strokeWidth="3"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "fog":
      return (
        <svg {...baseProps}>
          {[20, 30, 40].map((y) => (
            <path key={y} d={`M10 ${y}h44`} stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" strokeLinecap="round" />
          ))}
        </svg>
      );
    case "drizzle":
    case "rain":
      return (
        <svg {...baseProps}>
          <path d="M18 36h28c7 0 12-5 12-11S53 14 46 14c-2 0-3 0-4 .4C39 10 34 8 29 8c-8 0-14 5-16 12-6 .5-11 5-11 11s5 10 11 10h5Z" fill="currentColor" fillOpacity="0.12" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" strokeLinejoin="round" />
          {[20, 32, 44].map((x) => (
            <line key={x} x1={x} y1="42" x2={x - 3} y2="52" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" strokeLinecap="round" />
          ))}
        </svg>
      );
    case "snow":
      return (
        <svg {...baseProps}>
          <path d="M18 34h28c7 0 12-5 12-11S53 12 46 12c-2 0-3 0-4 .4C39 8 34 6 29 6c-8 0-14 5-16 12-6 .5-11 5-11 11s5 10 11 10h5Z" fill="currentColor" fillOpacity="0.12" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" strokeLinejoin="round" />
          {[18, 30, 42].map((x) => (
            <g key={x} transform={`translate(${x} 48)`}>
              <line x1="0" y1="-5" x2="0" y2="5" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="2.4" strokeLinecap="round" />
              <line x1="-5" y1="0" x2="5" y2="0" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="2.4" strokeLinecap="round" />
              <line x1="-3.5" y1="-3.5" x2="3.5" y2="3.5" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="2.4" strokeLinecap="round" />
              <line x1="3.5" y1="-3.5" x2="-3.5" y2="3.5" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="2.4" strokeLinecap="round" />
            </g>
          ))}
        </svg>
      );
    case "thunder":
      return (
        <svg {...baseProps}>
          <path d="M18 34h28c7 0 12-5 12-11S53 12 46 12c-2 0-3 0-4 .4C39 8 34 6 29 6c-8 0-14 5-16 12-6 .5-11 5-11 11s5 10 11 10h5Z" fill="currentColor" fillOpacity="0.12" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" strokeLinejoin="round" />
          <path d="M33 36 24 50h9l-5 10 14-18h-9l5-6Z" fill={strokeColor} fillOpacity="0.96" />
        </svg>
      );
    default:
      return (
        <svg {...baseProps}>
          <path d="M18 36h28c7 0 12-5 12-11S53 14 46 14c-2 0-3 0-4 .4C39 10 34 8 29 8c-8 0-14 5-16 12-6 .5-11 5-11 11s5 10 11 10h5Z" fill="currentColor" fillOpacity="0.12" stroke={strokeColor} strokeOpacity="0.96" strokeWidth="3" strokeLinejoin="round" />
        </svg>
      );
  }
};

export default WeatherIcon;
